module.exports = __webpack_public_path__ + "static/media/16.7fa1a23f.png";